import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Shield, Coffee, Zap, Gift } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    icon: BookOpen,
    title: '14-Day Plan',
    desc: 'Tiny daily actions (AM anchor, midday reset, PM close).'
  }, {
    icon: Shield,
    title: 'Minimum Effective Reset',
    desc: 'Your bad-day version that still counts.'
  }, {
    icon: Coffee,
    title: 'Home-Relief Menu',
    desc: 'So you never have to decide what to do.'
  }, {
    icon: Zap,
    title: '"Hard Hour" Buffers',
    desc: 'So evenings stop detonating.'
  }];
  const bonuses = ['Laminated-style Protocol Pages', 'Partner One-Pager', 'Printable Emergency Cards'];
  return <Section background="beige" data-id="element-176">
      <h2 className="text-3xl md:text-4xl font-serif text-[#4A4238] mb-12 text-center" data-id="element-177">
        What's Inside
      </h2>

      <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-178">
        {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-xl flex items-start gap-4 shadow-sm" data-id="element-179">
            <div className="text-[#7BA99E] mt-1" data-id="element-180">
              <feature.icon size={24} data-id="element-181" />
            </div>
            <div data-id="element-182">
              <h3 className="font-serif font-bold text-lg text-[#4A4238] mb-1" data-id="element-183">
                {feature.title}
              </h3>
              <p className="text-[#8C7E6E]" data-id="element-184">{feature.desc}</p>
            </div>
          </div>)}
      </div>

      <div className="bg-[#4A4238] text-[#FAF7F2] rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-185">
        <div className="relative z-10" data-id="element-186">
          <div className="flex items-center gap-3 mb-6" data-id="element-187">
            <Gift className="text-[#7BA99E]" data-id="element-188" />
            <h3 className="text-2xl font-serif" data-id="element-189">Included Bonuses</h3>
          </div>
          <ul className="space-y-4" data-id="element-190">
            {bonuses.map((bonus, i) => <li key={i} className="flex items-center gap-3 text-lg" data-id="element-191">
                <span className="w-1.5 h-1.5 bg-[#7BA99E] rounded-full" data-id="element-192"></span>
                {bonus}
              </li>)}
          </ul>
        </div>
        {/* Decorative circle */}
        <div className="absolute -right-10 -bottom-20 w-64 h-64 bg-[#7BA99E] opacity-10 rounded-full blur-2xl" data-id="element-193"></div>
      </div>
    </Section>;
}